import { useEffect, useState } from "react";
import { useLocation, Link, useParams } from "react-router-dom";
import axios from "axios";
import BASE_URL from "../../configs/api";
import { FiHome, FiChevronRight, FiChevronLeft, FiFilm } from "react-icons/fi";
import { FaPlay } from "react-icons/fa";

const CountryMovie = () => {
  const location = useLocation();
  const { code, name } = useParams();

  const [phimCountry, setPhimCountry] = useState({ results: [], count: 0 });
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 24;

  useEffect(() => {
    if (!code) {
      console.error("Thiếu mã quốc gia");
      return;
    }

    const fetchPhimCountry = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${BASE_URL}/api/phim_quocgia/`, {
          params: {
            quoc_gia: code,
            page: currentPage,
          },
        });

        setPhimCountry(response.data);
      } catch (error) {
        console.error("Lỗi khi gọi API:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPhimCountry();
  }, [code, currentPage]);

  const totalPages = Math.ceil(phimCountry.count / itemsPerPage);

  const goToPrevPage = () => setCurrentPage((p) => Math.max(p - 1, 1));
  const goToNextPage = () => setCurrentPage((p) => Math.min(p + 1, totalPages));
  useEffect(() => {
    setCurrentPage(1);
  }, [code]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center  text-white">
        <div className="text-center">
          <h1 className="text-xl lg:text-6xl font-bold text-orange-300 mb-4 animate-bounce">
            Đang tải đợi xíu
          </h1>
        </div>
      </div>
    );
  }

  if (phimCountry.results.length === 0) {
    return (
      <div className="min-h-screen flex items-center justify-center  text-white">
        <h1 className="text-xl lg:text-6xl font-bold text-orange-300 animate-bounce">
          Đang trong thời gian cập nhật
        </h1>
      </div>
    );
  }

  return (
    <div className="xl:container xl:mx-auto px-4 min-h-screen">
      <div className="p-3.5 rounded-lg mt-4 mb-4 w-full h-auto bg-[#2a2d42] bg-opacity-50">
        <nav className="text-sm text-white flex items-center flex-wrap gap-x-1.5">
          <Link
            to="/"
            className="hover:underline hover:text-orange-300 inline-flex items-center transition-colors duration-150"
          >
            <FiHome className="mr-1.5 w-4 h-4" />
            Trang chủ
          </Link>

          <FiChevronRight className="w-4 h-4 text-neutral-400" />

          <span className="text-orange-300 font-medium inline-flex items-center">
            <FiFilm className="mr-1.5 w-4 h-4" />
            Phim {name || "không xác định"}
          </span>
        </nav>
      </div>

      <div className="mb-6 md:mb-8 flex flex-col sm:flex-row sm:items-center sm:justify-between">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white font-seogoe relative ">
          {name}{" "}
          <div className="absolute -bottom-2 left-0 w-full h-1 bg-gradient-to-r from-orange-500 via-orange-400 to-transparent rounded-full"></div>
        </h2>

        <span className="text-sm sm:text-base text-white/70 pt-4 sm:mt-0">
          Tìm thấy {phimCountry.count} phim
        </span>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 xl:grid-cols-8 gap-4 md:gap-3">
        {phimCountry.results.map((movie) => (
          <div
            key={movie.id}
            className="movie-card transition-transform duration-200 ease-in-out"
          >
            <div className="relative rounded-md overflow-hidden group">
              <Link to={`/phim/${movie.slug}`}>
                <img
                  src={movie.poster_url}
                  alt={movie.ten_phim}
                  className="w-full h-auto aspect-[2/3] object-cover"
                />
                <div className="absolute bottom-0 left-1/2 -translate-x-1/2 flex flex-row justify-center items-start z-20">
                  <div className="bg-gradient-to-r from-gray-700 to-gray-600 text-white text-[10px] leading-tight md:text-xs font-semibold px-2 py-0.5 rounded-tl-[0.2rem] shadow-md whitespace-nowrap">
                    {movie.ngon_ngu
                      ? movie.ngon_ngu
                          .replace("Vietsub", "P.Đ")
                          .replace("Lồng Tiếng", "T.M")
                          .replace("Thuyết Minh", "T.M")
                      : "Đang cập nhật"}
                  </div>
                  <div className="bg-gradient-to-r from-[#C02425] to-[#fd9a05] text-white text-[10px] leading-tight md:text-xs font-semibold px-2 py-0.5 rounded-tr-[0.2rem] shadow-md whitespace-nowrap">
                    {(movie.tinh_trang || "Đang cập nhật")
                      .replace(/Hoàn Tất/gi, "HT")
                      .trim() || "Đang cập nhật"}
                  </div>
                </div>
                <div className="absolute inset-0 flex items-center justify-center bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="bg-orange-500 rounded-full p-3 shadow-lg">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6 text-white"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="currentColor"
                        d="M21.409 9.353a2.998 2.998 0 0 1 0 5.294L8.597 21.614C6.534 22.737 4 21.277 4 18.968V5.033c0-2.31 2.534-3.769 4.597-2.648z"
                      />
                    </svg>
                  </div>
                </div>

                <div className="absolute inset-0 bg-black/30 opacity-0 group-hover:opacity-20 transition duration-300" />
              </Link>
            </div>
            <div className="mt-2 text-center">
              <Link
                to={`/phim/${movie.slug}`}
                className="text-white text-sm font-medium  hover:text-yellow-200 truncate line-clamp-none"
                title={movie.ten_phim}
              >
                {movie.ten_phim}
              </Link>
              <p
                className="text-gray-400 text-xs truncate"
                title={movie.ten_khac}
              >
                {movie.ten_khac}
              </p>
            </div>
          </div>
        ))}
      </div>

      {totalPages > 1 && (
        <div className="flex flex-row justify-center items-center mt-10 md:mt-12 space-x-2 sm:space-x-3">
          {/* Nút Trang Trước */}
          <button
            onClick={goToPrevPage}
            disabled={currentPage === 1}
            className="inline-flex items-center justify-center h-10 w-10 sm:w-auto sm:px-4 bg-neutral-700 text-neutral-200 rounded-md shadow-sm 
                 border border-neutral-600 transition-all duration-200 ease-in-out 
                 hover:bg-neutral-600 hover:text-orange-500 hover:border-orange-500 
                 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-opacity-50
                 disabled:opacity-50 disabled:cursor-not-allowed 
                 disabled:hover:bg-neutral-700 disabled:hover:text-neutral-200 disabled:hover:border-neutral-600"
            aria-label="Trang trước"
          >
            <FiChevronLeft className="h-5 w-5 flex-shrink-0" />
            <span className="hidden sm:inline ml-1.5 text-sm">Trước</span>
          </button>

          {/* Hiển thị Trang Hiện Tại / Tổng Số Trang */}
          <span
            className="flex items-center justify-center h-10 px-4 text-white font-semibold 
                 bg-orange-500 rounded-md text-sm sm:text-base shadow-sm"
            aria-current="page"
          >
            {`${currentPage} / ${totalPages}`}
          </span>

          {/* Nút Trang Sau */}
          <button
            onClick={goToNextPage}
            disabled={currentPage === totalPages}
            className="inline-flex items-center justify-center h-10 w-10 sm:w-auto sm:px-4 bg-neutral-700 text-neutral-200 rounded-md shadow-sm 
                 border border-neutral-600 transition-all duration-200 ease-in-out 
                 hover:bg-neutral-600 hover:text-orange-500 hover:border-orange-500 
                 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-opacity-50
                 disabled:opacity-50 disabled:cursor-not-allowed
                 disabled:hover:bg-neutral-700 disabled:hover:text-neutral-200 disabled:hover:border-neutral-600"
            aria-label="Trang sau"
          >
            <span className="hidden sm:inline mr-1.5 text-sm">Sau</span>
            <FiChevronRight className="h-5 w-5 flex-shrink-0" />
          </button>
        </div>
      )}
    </div>
  );
};

export default CountryMovie;
